export enum StatusClass {
  Scheduled = 0,
  Done = 1,
  Delayed = 3,
  ChangedTeacher = 4,
  Reschedule = 5,
  PartialConfirmed = 6,
  Unchecked = 7,
  Holiday = 8
}

export const StatusClassLabel = new Map<number, string>([
  [StatusClass.Scheduled, 'Agendada'],
  [StatusClass.Done, 'Concluída'],
  [StatusClass.Delayed, 'Atrasada'],
  [StatusClass.ChangedTeacher, 'Professor Alterado'],
  [StatusClass.Reschedule, 'Reagendada'],
  [StatusClass.PartialConfirmed, 'Confirmada Parcial'],
  [StatusClass.Unchecked, 'Desmarcada'],
  [StatusClass.Holiday, 'Feriado/Recesso']
]);

export const StatusClassCss = new Map<number, string>([
  [StatusClass.Scheduled, 'status-class-scheduled'],
  [StatusClass.Done, 'status-class-done'],
  [StatusClass.Delayed, 'status-class-delayed'],
  [StatusClass.ChangedTeacher, 'status-class-changed-teacher'],
  [StatusClass.Reschedule, 'status-class-reschedule'],
  [StatusClass.PartialConfirmed, 'status-class-partial-confirmed'],
  [StatusClass.Unchecked, 'status-class-unchecked'],
  [StatusClass.Holiday, 'status-class-holiday']
]);

export const StatusClassCssContrast = new Map<number, string>([
  [StatusClass.Scheduled, 'status-class-scheduled-contrast'],
  [StatusClass.Done, 'status-class-done-contrast'],
  [StatusClass.Delayed, 'status-class-delayed-contrast'],
  [StatusClass.ChangedTeacher, 'status-class-changed-teacher-contrast'],
  [StatusClass.Reschedule, 'status-class-reschedule-contrast'],
  [StatusClass.PartialConfirmed, 'status-class-partial-confirmed-contrast'],
  [StatusClass.Unchecked, 'status-class-unchecked-contrast'],
  [StatusClass.Holiday, 'status-class-holiday-contrast']
]);
